import { authHeader } from "./data";
import authAxios from "./data";
import qs from "qs";

const fetchDashboardData = async (request: any) => {
  const response = await authAxios.get("/api/Dashboard", {
    params: request,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
    headers: authHeader()
  });

  return response.data;
};

const fetchHistory = async (request: any) => {
  const response = await authAxios.get("/api/Dashboard/History", {
    params: request,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
    headers: authHeader()
  });

  return response.data;
};

const calculate = async () => {
  const response = await authAxios.post("/api/Dashboard/Calculate", null, {
    headers: authHeader()
  });

  return response.data;
};

export const DashboardService = {
  fetchDashboardData,
  fetchHistory,
  calculate
};
